'use client';
import { forwardRef } from 'react';
import { Box } from '@wanteddev/wds-engine';
import { dividerStyle } from './style.mjs';
import { jsx } from 'react/jsx-runtime';

var Divider = forwardRef(
  ({
    size = "100%",
    thickness = "1px",
    vertical = false,
    color = "palette.line.normal.normal",
    xs,
    sm,
    md,
    lg,
    xl,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx(
      Box,
      {
        as: "hr",
        ref,
        ...props,
        sx: [
          dividerStyle({
            thickness,
            xs,
            sm,
            md,
            lg,
            xl,
            vertical,
            color,
            size
          }),
          props.sx
        ]
      }
    );
  }
);
Divider.displayName = "Divider";
var divider_default = Divider;

export { divider_default as default };
